import { render, staticRenderFns } from "./Followups.vue?vue&type=template&id=0dd12d8c"
import script from "./Followups.vue?vue&type=script&lang=js"
export * from "./Followups.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports